<template>
  <v-card class="elevation-12 mb-6">
    <v-card-title class="px-9 pt-7">
      Vložené hodnoty
    </v-card-title>

   <IndividualReadingInsertedValues
      v-if="value.type.name === 'INDIVIDUAL_READING'"
      :individualReading = value.individualReading
    />

    <BulkFilesInsertedValues
      v-else-if="!value.individual && (value.file || value.resultFile)"
      :file = value.file
      :resultFile = value.resultFile
    />

    <IndividualDistributionRenewalInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_DISTRIBUTION_RENEWAL'"
      :individualDistributionRenewal = value.individualDistributionRenewal
      :createdAt = value.createdAt
    />

    <IndividualDistributionInterruptionInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_DISTRIBUTION_INTERRUPTION'"
      :individualDistributionInterruption = value.individualDistributionInterruption
    />

    <IndividualCapacityChangeAnnualInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_CAPACITY_ANNUAL_CHANGE'"
      :individualCapacityChangeAnnual = individualCapacityChangeAnnual()
      :updatedAt = value.updatedAt
    />

    <IndividualCapacityChangeMonthlyInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_CAPACITY_MONTHLY_CHANGE'"
      :individualCapacityChangeMonthly = individualCapacityChangeMonthly()
      :updatedAt = value.updatedAt
    />

    <IndividualTrialOperationInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_TRIAL_OPERATION'"
      :individualTrialOperation = value.individualTrialOperation
      :file = value.file
    />

    <IndividualBillingExceptionInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_BILLING_EXCEPTION'"
      :individualBillingException = value.individualBillingException
      :file = value.file
    />

    <IndividualControlStagesChangeInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_CONTROL_STAGES_CHANGE'"
      :individualControlStagesChange = value.individualControlStagesChange
    />

    <BulkOtherChangeInsertedValues
      v-else-if="value.bulkOtherChange"
      :bulkOtherChange="value.bulkOtherChange"
    />

    <IndividualReservedPowerChangeInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_RESERVED_POWER_CHANGE'"
      :individualReservedPowerChange = value.individualReservedPowerChange
      :file = value.file
    />

    <RequestNNInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_CONNECTION_AGREEMENT_LV'"
      :individualConnectionAgreementLv="value.individualConnectionAgreementLv"
    />

    <RequestVNInsertedValues
      v-else-if="value.type.name === 'INDIVIDUAL_CONNECTION_AGREEMENT_HV'"
      :individualConnectionAgreementHv="value.individualConnectionAgreementHv"
      :distributionSubstation="distributionSubstation"
    />

    <AgreementNNInsertedValues
      v-else-if="value.lvConnectionAgreementUpdate"
      :lvConnectionAgreementUpdate="value.lvConnectionAgreementUpdate"
    />
  </v-card>
</template>

<script>
import BulkOtherChangeInsertedValues from '@/components/inserted-values/BulkOtherChangeInsertedValues.vue';
import RequestNNInsertedValues from '@/components/inserted-values/RequestNNInsertedValues.vue';
import RequestVNInsertedValues from '@/components/inserted-values/RequestVNInsertedValues.vue';
import AgreementNNInsertedValues from '@/components/inserted-values/AgreementNNInsertedValues.vue';
import IndividualReservedPowerChangeInsertedValues from '@/components/inserted-values/IndividualReservedPowerChangeInsertedValues.vue';
import IndividualControlStagesChangeInsertedValues from '@/components/inserted-values/IndividualControlStagesChangeInsertedValues.vue';
import IndividualBillingExceptionInsertedValues from '@/components/inserted-values/IndividualBillingExceptionInsertedValues.vue';
import IndividualTrialOperationInsertedValues from '@/components/inserted-values/IndividualTrialOperationInsertedValues.vue';
import IndividualCapacityChangeMonthlyInsertedValues from '@/components/inserted-values/IndividualCapacityChangeMonthlyInsertedValues.vue';
import IndividualCapacityChangeAnnualInsertedValues from '@/components/inserted-values/IndividualCapacityChangeAnnualInsertedValues.vue';
import IndividualDistributionInterruptionInsertedValues from '@/components/inserted-values/IndividualDistributionInterruptionInsertedValues.vue';
import IndividualDistributionRenewalInsertedValues from '@/components/inserted-values/IndividualDistributionRenewalInsertedValues.vue';
import BulkFilesInsertedValues from '@/components/inserted-values/BulkFilesInsertedValues.vue';
import IndividualReadingInsertedValues from '@/components/inserted-values/IndividualReadingInsertedValues.vue';

export default {
  name: 'InsertedValues',
  components: {
    BulkOtherChangeInsertedValues,
    RequestNNInsertedValues,
    RequestVNInsertedValues,
    AgreementNNInsertedValues,
    IndividualReservedPowerChangeInsertedValues,
    IndividualControlStagesChangeInsertedValues,
    IndividualBillingExceptionInsertedValues,
    IndividualTrialOperationInsertedValues,
    IndividualCapacityChangeMonthlyInsertedValues,
    IndividualCapacityChangeAnnualInsertedValues,
    IndividualDistributionInterruptionInsertedValues,
    IndividualDistributionRenewalInsertedValues,
    BulkFilesInsertedValues,
    IndividualReadingInsertedValues,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  methods: {
    individualCapacityChangeAnnual() {
      if (this.value.individualCapacityChangeAnnual != null) {
        return this.value.individualCapacityChangeAnnual;
      }
      return this.value.typeSpecificData;
    },
    individualCapacityChangeMonthly() {
      if (this.value.individualCapacityChangeMonthly != null) {
        return this.value.individualCapacityChangeMonthly;
      }
      return this.value.typeSpecificData;
    },
  },
};
</script>
